import React, { Component } from 'react';
import Spinner from 'react-bootstrap/Spinner'

import { StringUtils } from '../utils';
import { Header, Button, PhoneInput, ValidationCodeInput } from '../components';
import { Routes as routes } from '../navigation';
import '../css/UserProfile.css';

class UserPhoneEdit extends Component {

  constructor(props) {
    super(props);
    let existing_user = this.props.user;
    let phone_number  = existing_user && existing_user.phone_number ? existing_user.phone_number : '';
    this.state = {
      phone_number: '',
      display_edit: false,
      display_verify_input: false,
      validation_code: '',
      loading_send: false,
      loading_verify: false,
    }
  }

  renderUserPhoneEdit = (user) => {
    if (!user) {
      return null
    }

    let phone_number  = user.phone_number;
    let no_phone      = !phone_number || phone_number === '';
    let display_phone = StringUtils.displayCodePhoneNumber(phone_number);
    let display_input = this.state.display_edit;
    let display_verify_input = this.state.display_verify_input;

    return <div className="standard-container">
      <Header title='Phone Number' icon='fas fa-mobile-alt'/>
      <div className="flex-container-column" style={{ }}>
        { display_input || display_verify_input ? null : this.renderDisplayPhoneSection(display_phone, no_phone) }
        { display_input && !display_verify_input ? this.renderPhoneInputSection() : null }
        { display_verify_input ? this.renderVerifySection() : null }
      </div>
    </div>
  }

  renderVerifySection = () => {
    let phone_number  = this.state.phone_number;
    let display_phone = StringUtils.displayCodePhoneNumber(phone_number);

    return <div className='flex-container-column' style={{ alignItems: 'center', padding: 15 }}>
      <span style={{ fontSize: 15, color: '#575757', alignSelf: 'center', marginTop: -4 }}>{ display_phone }</span>
      <span style={{ fontSize: 10, color: '#1dc2ff', alignSelf: 'center', marginTop: -2, marginBottom: 8 }}>VERIFICATION CODE SENT</span>
      <ValidationCodeInput
        value={this.state.validation_code}
        style={{ width: 100, padding: 0, fontSize: 20, textAlign: 'center', marginBottom: 8 }}
        onChange={ (code) => { this.setState({ ...this.state, validation_code: code.toUpperCase() }) }}
        code_length={6}
        completeAction={ (code) => {
          this.validationAction(code);
          this.setState({ ...this.state, validation_code: code.toUpperCase() })
        }}
      />
      <div className='instant-join-session-button'
           style={{  }}
           onClick={ () => { this.validationAction(this.state.validation_code) }}>
           { this.state.loading_verify ? <Spinner as="span" animation="border" size='sm' style={{ color: 'white', marginRight: 8 }} />
                                       : <span className='fas fa-check-circle' style={{ marginRight: 8 }} /> }
           <span>{ 'Verify & Save Phone Number' }</span>
      </div>
    </div>
  }

  renderPhoneInputSection = () => {
    let send_verification_loading = this.state.loading_send;
    return <div className='flex-container-column' style={{ padding: 15 }}>
      <span style={{ fontSize: 13, color: 'grey', marginBottom: 15, textAlign: 'center' }}>Enter a phone number. We will send you a verification code in a text message.</span>
      <div className='flex-container-column' style={{ marginBottom: 15, alignItems: 'center' }}>
        <PhoneInput value={this.state.phone_number}
                    style={{  }}
                    onChange={ (text) => {
                      this.setState({ ...this.state, phone_number: text })
                    }}
                  />
      </div>
      <div className='flex-container-row' style={{ alignItems: 'center', justifyContent: 'center' }}>
        <span className='instant-cancel-button'
              style={{ marginRight: 5 }}
              onClick={ () => {
                this.setState({ ...this.state, display_edit: false, phone_number: '', loading_send: false })
              }}>
              <span style={{ fontSize: 13, fontWeight: 'bold', color: '#1dc2ff' }}>Cancel</span>
        </span>
        <div className='instant-join-session-button'
             style={{  }}
             onClick={ () => { this.sendVerificationText() }}>
             { send_verification_loading ? <Spinner as="span" animation="border" size='sm' style={{ color: 'white', marginRight: 8 }} />
                                         : <span className='fas fa-comment-alt' style={{ marginRight: 8 }} /> }
             <span>{ 'Send Verification Text' }</span>
        </div>
      </div>
    </div>
  }

  renderDisplayPhoneSection = (display_phone, no_phone) => {
    let button_title = no_phone ? 'Add Phone Number'   : 'Change Phone Number';
    let button_icon  = no_phone ? 'fas fa-plus-circle' : 'fas fa-edit';
    return <div className='flex-container-column' style={{ padding: 15 }}>
      { no_phone ? <div className='flex-container-column' >
                     <span style={{ fontSize: 13, color: 'grey', marginBottom: 15 }}>Add a phone number to your account. This will allow you to sign in using your phone and receive notifications through text messages.</span>
                   </div>
                 : <div className='flex-container-column'>
                     <span style={{ fontSize: 15, color: '#575757', alignSelf: 'center', marginTop: -4 }}>{ display_phone }</span>
                     <span style={{ fontSize: 10, color: '#1dc2ff', alignSelf: 'center', marginTop: -2, marginBottom: 8 }}>CURRENT PHONE NUMBER</span>
                   </div> }

      <div className='instant-join-session-button'
           style={{ alignSelf: no_phone ? 'flex-end' : 'center' }}
           onClick={ () => { this.setState({ ...this.state, display_edit: true }) }}>
           <span className={button_icon} style={{ marginRight: 5 }} />
           <span>{ button_title }</span>
      </div>
    </div>
  }

  render() {
    let user         = this.props.user;
    let phone_number = user && user.phone_number ? user.phone_number : '';
    let no_phone     = !phone_number || phone_number === '';
    if (this.props.hide && !no_phone) {
      return null;
    }
    return this.renderUserPhoneEdit(user);
  }

  sendVerificationText = () => {
    let token = this.props.token;
    this.props.userActions.sendPhoneVerificationCode(token, this.state.phone_number, this.sendSuccess, this.sendFailure);
    this.setState({ ...this.state, loading_send: true });
  }

  sendSuccess = () => {
    this.setState({ ...this.state, display_verify_input: true, loading_send: false });
  }

  sendFailure = () => {
    this.setState({ ...this.state, loading_send: false });
  }

  validationAction = (code) => {
    let token   = this.props.token;
    let user_id = this.props.user._id;
    this.props.userActions.verifyPhoneCode(token, user_id, this.state.phone_number, code, this.verifySuccess, this.verifyFailure);
    this.setState({ ...this.state, loading_verify: true });
  }

  verifySuccess = () => {
    this.setState({ ...this.state, loading_verify: false, display_edit: false, display_verify_input: false });
  }

  verifyFailure = () => {
    this.setState({ ...this.state, loading_verify: false, display_edit: false, display_verify_input: false });
  }

}


export default UserPhoneEdit
